const NotRegisteredCard = () =>
  import("@/components/BankCard/NotRegisteredCard/index");
import { OperationService } from "@/services";
export default {
  name: "add-card",
  components: { NotRegisteredCard },
  props: [],
  data() {
    return {
      cardNumber: "",
      verificationCounterStatus: false,
      verificationBtn: false,
      notRegisteredCardDialog: false,
      addCardData: "",
      loading: false,
      cardNumberValidation: ""
    };
  },
  computed: {},
  mounted() {},
  methods: {
    checkOutCardNumber() {
      let bankCard = this.cardNumber?.replace(/-/gi, "");
      if (bankCard.length < 16) {
        this.cardNumberValidation = this.$t(
          "dialogs.addCard.invalidCardNumber"
        );
      } else {
        this.verificationCounterStatus = true;
        this.loading = true;
        OperationService.addBankCard(bankCard)
          .then(response => {
            if (response.status === 200) {
              this.loading = false;
              this.verificationBtn = true;
              this.cardNumber = "";
              setTimeout(() => {
                this.verificationBtn = false;
                this.$emit("confirmAddCard", false);
              }, 2000);
            }
          })
          .catch(error => {
            if (error) {
              this.loading = false;
              this.cardNumber = "";
              this.addCardData =
                error.data.errors.length !== 0
                  ? error.data.errors.bank_card[0]
                  : error.data.message;
              this.verificationCounterStatus = false;
              this.$emit("confirmAddCard", false);
              this.notRegisteredCardDialog = true;
            }
          });
      }
    },
    checkCardNumberValidation() {
      this.cardNumberValidation = "";
    }
  }
};
